import styled from "@emotion/styled";
import { Box } from "@mui/system";

const ControlWrapper = styled(Box)`
  display: flex;
  flex: unset;

  @media (max-width: 1400px) {
    flex-wrap: wrap;
  }
`;

const SearchWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex: auto;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;  
  @media (max-width: 650px) {
    flex-wrap: wrap;
  }
`;

export { ButtonWrapper, SearchWrapper, ControlWrapper };
